import { Context } from "hono";
import z from "zod";

export const projectFileSchema = z.object({
  path: z.string(),
  content: z.string(),
  readOnly: z.boolean().default(false),
});

export type ProjectFile = z.infer<typeof projectFileSchema>;

export type GetProjectFilesResponseBody = {
  files: ProjectFile[];
};

export type GetProjectFilesHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      GetProjectFilesResponseBody | { error: string }
    >
  >
>;
